<template>
  <div class="admin-new-order-builder-discount">
    <transition name="slide-x-transition" mode="out-in">
      <v-row
        dense
        class="text-right my-1"
        align="baseline"
        justify="space-between"
      >
        <v-col cols="4">
          <v-text-field
            placeholder="Discount Name"
            @input="$emit('update', { item_name: $event })"
            outlined
            dense
            hide-details
          />
        </v-col>

        <v-col cols="2">
          <v-text-field
            :value="price_in_usd"
            type="number"
            min="0"
            prefix="$"
            dense
            hide-details
            outlined
            @input="$emit('update', { custom_price: $event * 100 })"
          />
        </v-col>
        <v-col cols="2">
          <v-text-field
            :value="quantity"
            type="number"
            min="1"
            dense
            hide-details
            outlined
            @input="$emit('update', { quantity: $event })"
          />
        </v-col>
        <v-col cols="2" class="text-center">{{
          formatUSD(item.price * item.quantity)
        }}</v-col>

        <v-col cols="auto">
          <BtnRemove @remove="$emit('remove')" />
        </v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
import formatUSD from '@/utils/formatUSD'
import CartItemModel from '@/models/CartItemModel'

import BtnRemove from '@/components/BtnRemove'
export default {
  name: 'AdminNewOrderBuilderDiscount',
  components: {
    BtnRemove,
  },
  props: {
    item: {
      type: CartItemModel,
      default: () => new CartItemModel(),
    },
  },
  data() {
    return {
      CartItemModel,
    }
  },
  computed: {
    price_in_usd() {
      return this.item.price / 100
    },
    quantity() {
      return this.item.quantity
    },
  },
  methods: {
    formatUSD,
    add() {
      this.$emit('add')
    },
  },
}
</script>
